import {PlayIcon} from '@features/video-upload/components/play-icon'
import {Button} from '@components/ui/button'
import {Spinner} from '@components/ui/spinner'
import {Trash01Icon} from '@components/ui/icon'
import {FC} from 'react'
import {useTranslation} from '@/translations/i18n.tsx'

interface VideoCardProps {
    fileName?: string
    fileSize?: number
    isLoading: boolean
    onDeleteVideo?: () => void
}
export const VideoCard: FC<VideoCardProps> = ({fileName, fileSize, isLoading, onDeleteVideo}) => {
    const {t} = useTranslation()

    return (
        <div className="grid items-center grid-cols-[minmax(0,1fr)_auto] gap-2 p-4 border border-neutral-300 rounded-xl [&_h3]:text-sm [&_h3]:font-medium [&_h3]:whitespace-nowrap [&_h3]:overflow-hidden [&_h3]:text-ellipsis [&_p]:text-sm [&_p]:text-neutral-500">
            <div className="flex gap-3">
                <PlayIcon />
                <div className="overflow-hidden">
                    <h3>{fileName ?? '-'}</h3>
                    <p>
                        {fileSize ? (
                            `${Math.round(fileSize / 1_000_000)}MB`
                        ) : isLoading ? (
                            <Spinner size={14} />
                        ) : (
                            t('admin:uploaded')
                        )}
                    </p>
                </div>
            </div>
            <Button shape="square" variant="ghost" size="sm" disabled={isLoading} onClick={onDeleteVideo}>
                {isLoading ? <Spinner /> : <Trash01Icon />}
            </Button>
        </div>
    )
}
